import axios from "axios";
import { API_URL } from '../api.js'

const api = `${API_URL}/import`

export default {
    async importFromBistro(restaurantId, bistroUrl) {
        const resp = await axios.post(`${api}/bistro`, {
            restaurantId,
            bistroUrl
        });
        return resp.data;
    },
};
